import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from 'react';
import { useJobContext } from "./JobPageLoader";
import ApplyModal from "../JobsPage/modals/ApplyModal";

export default function JobPageContent() {
  const { job } = useJobContext();
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <div className='__jobs'>
      <div className='content'>
        <div className='bottom-section'>
          <div className='search-results'>

            <div className='job-card'>
              <div className='job-header'>
                <div className='job-title'>{ job.title }</div>
              </div>
              { job.tags && job.tags.trim() !== '' && (
                <div className='tags'>
                  { job.tags.split(',').map((tag, idx) => (
                    <div key={ idx } className='tag'>
                      { tag.trim() }
                    </div>
                  )) }
                </div>
              ) }
              { job.budget && (
                <div className='budget'>
                  Budget: ${ job.budget }
                </div>
              ) }
              <div className='body'>
                { job.description }
              </div>
              { job.location && (
                <div className='location'>
                  <FontAwesomeIcon icon={ faLocationDot } /> { job.location }
                </div>
              ) }
              <div className='apply'>
                <button className="ppy-btn ppy-btn-primary" onClick={ () => setSelectedJob(job) }>
                  Apply Now
                </button>
              </div>
              <div className="dates">
                <div>Posted { new Date(job.created_at).toLocaleDateString('en-US') }</div>
                { job.expires_at && (
                  <div className="expires-at">
                    <div>Expires { new Date(job.expires_at).toLocaleDateString('en-US') }</div>
                    { new Date(job.expires_at) < new Date() && (
                      <div className="expired">Expired</div>
                    ) }
                  </div>
                ) }
              </div>
            </div>

          </div>
        </div>
      </div>

      <ApplyModal
        show={ !!selectedJob }
        handleClose={ () => setSelectedJob(null) }
        job={ selectedJob }
      />
    </div>
  );
}
